import { ROOT_URL } from 'gatsby-env-variables'
import classNames from 'classnames'
import { Link } from 'gatsby'
import './Button.scss'
import analytics from '@mobi/libraries/analytics'

const arrowSVG = (
  <div className="svgContainer">
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.709351 6.21512C0.736084 6.27945 0.774449 6.33775 0.821832 6.38743C0.82524 6.39101 0.828693 6.39453 0.832193 6.39802L5.61842 11.1687C5.83871 11.3883 6.19588 11.3883 6.41618 11.1687C6.63647 10.9492 6.63647 10.5931 6.41618 10.3736L2.59259 6.56236H14.7692C15.0807 6.56236 15.3333 6.31062 15.3333 6.00008C15.3333 5.68955 15.0807 5.43781 14.7692 5.43781H2.59259L6.41618 1.62661C6.63647 1.40703 6.63647 1.05102 6.41618 0.831434C6.19588 0.611853 5.83871 0.611853 5.61842 0.831434L0.831848 5.60249C0.807225 5.62704 0.785355 5.65328 0.766236 5.68085C0.74336 5.71384 0.724424 5.74873 0.709429 5.78485C0.681847 5.85115 0.666626 5.92385 0.666626 6.00008C0.666626 6.07625 0.68182 6.14888 0.709351 6.21512Z"
        fill="currentColor"
      />
    </svg>
  </div>
)

const Button = ({
  onClick,
  children,
  className,
  size = 'medium',
  theme,
  icon,
  ghost,
  inverted,
  isDisabled,
  isExternalLink,
  type,
  to,
  hasElementClickedEvent = true,
  ...props
}) => {
  const customOnClick = (ev) => {
    const element = ev.currentTarget

    if (hasElementClickedEvent) {
      analytics.track('elementClicked', {
        location: element.dataset.makeLocation,
        position: element.dataset.makePosition,
        elementType: element.dataset.makeElement,
        text: element.textContent,
        htmlId: element.dataset.unique,
        actionOutcome: element.dataset.makeActionoutcome,
        outboundUrl: element.dataset.makeOutboundurl,
        useCorrelationId: element.dataset.makeUsecorrelationid,
      })
    }

    const isConsultButton = [
      'consultar',
      'consulte suas dívidas',
      'consultar dívidas',
    ].includes(children)

    const isConsultHeroButton = [
      '63a2d907-4325-4e21-a45f-d420493b4f10',
    ].includes(element.dataset.unique)

    if (ROOT_URL && isConsultButton && !isConsultHeroButton) {
      analytics.track('formStarted')
    }

    analytics.track('gaButtonClick', {
      id: element.dataset.unique,
      text: element.dataset.trackingText || element.textContent,
    })
    onClick && onClick(ev)
  }

  const ariaProps = {
    'aria-disabled': !!isDisabled,
  }

  const componentClass = classNames(className, 'rvc-mobi-button', `-${size}`, {
    '-icon': icon,
    '-inverted': inverted,
    '-ghost': ghost,
    '-disabled': isDisabled,
    '-icon-right': icon === 'right',
    '-icon-left': icon === 'left',
    [`-${theme}`]: theme,
  })

  if (type === 'link') {
    return isExternalLink ? (
      <a
        className={componentClass}
        href={to}
        {...props}
        onClick={customOnClick}
        data-contrast="button"
      >
        {icon === 'left' && arrowSVG}
        {children}
      </a>
    ) : (
      <Link
        className={componentClass}
        data-contrast="button"
        to={to}
        {...props}
        onClick={customOnClick}
      >
        {icon === 'left' && arrowSVG}
        {children}
      </Link>
    )
  }

  return (
    <button
      data-contrast="button"
      type={type}
      className={componentClass}
      disabled={isDisabled}
      {...ariaProps}
      {...props}
      onClick={customOnClick}
    >
      {icon === 'left' && arrowSVG}
      {children}
    </button>
  )
}

export default Button
